import React from 'react';
import { ProjectEquipmentKpiRow } from './ProjectEquipmentKpiRow';
import { ProjectEquipmentHeader } from './ProjectEquipmentHeader';
import { ProjectEquipmentList } from './ProjectEquipmentList';
import { ProjectEquipmentSidebar } from './ProjectEquipmentSidebar';
import { useProjectEquipment } from '../hooks/useProjectEquipment';

export function ProjectEquipmentMain() {
  const { data, isLoading } = useProjectEquipment();

  if (isLoading) {
    return <div className="p-10 text-center text-slate-400">Đang tải dữ liệu thiết bị...</div>;
  }

  return (
    <div className="space-y-6">
      {/* KPI Cards */}
      <ProjectEquipmentKpiRow kpis={data.kpis} />

      <div className="grid grid-cols-1 xl:grid-cols-12 gap-6 items-start">
        {/* Main Content */}
        <div className="xl:col-span-9 space-y-6">
          <ProjectEquipmentHeader />
          <ProjectEquipmentList equipment={data.equipment} />
        </div>

        {/* Sidebar */}
        <div className="xl:col-span-3">
          <ProjectEquipmentSidebar data={data} />
        </div>
      </div>
    </div>
  );
}
